import { RouteProp } from '@react-navigation/native';
import React, { useMemo } from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import useOrganizationClientInvitations from '../../../../../hooks/api/useOrganizationClientInvitations';
import useOrganizationInvitationDefinitions from '../../../../../hooks/api/useOrganizationInvitationDefinitions';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import OrganizationClientInvitationFields, {
    getDefaultFormValue,
} from '../../../../shared/OrganizationClientInvitations/OrganizationClientInvitationFields';
import { Form } from '../../../../v2BaseComponents/Form';
import MaybePublicOrgMissingInfoAlert from '../../../../shared/MaybePublicOrgMissingInfoAlert';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('profiles.addClientInvitation', {
    send: 'Send',
});

export type AddClientInvitationScreenOwnProps = {};

export type AddClientInvitationScreenProps = AddClientInvitationScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'add-client-invitation'>;
};

const AddClientInvitationScreen: React.FC<AddClientInvitationScreenProps> = () => {
    const goBack = useGoBack();
    const { createClientInvitation, isCreatingClientInvitation } = useOrganizationClientInvitations({
        onCreateInvitation: goBack,
    });
    const { invitationDefinitions, isLoadingInvitationDefinitions } = useOrganizationInvitationDefinitions({});
    const defaultFormValue = useMemo(() => getDefaultFormValue(invitationDefinitions), [invitationDefinitions]);

    return (
        <AnimateLoadedContent isLoading={isCreatingClientInvitation || isLoadingInvitationDefinitions}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={defaultFormValue}
                    onSubmit={(values) =>
                        createClientInvitation({
                            ...values,
                            expirationDateTime: values.expirationDateTime
                                ? new Date(values.expirationDateTime).toISOString()
                                : undefined,
                        })
                    }
                    onCancel={goBack}
                    saveText={intl('send')}
                    saveIcon="Send"
                >
                    {({ values }) => (
                        <>
                            <MaybePublicOrgMissingInfoAlert />
                            <OrganizationClientInvitationFields
                                invitationDefinitions={invitationDefinitions}
                                value={values}
                            />
                        </>
                    )}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddClientInvitationScreen);
